import { PropsWithChildren } from "react";

interface IMultipleComponentPopup {
    shouldCloseOnClickOutside?: boolean;
    onCloseCallback?: () => void;
    isBackgroundGrey?: boolean;
    contentJustification?: "center" | "left" | "right";
    contentMarginTop?: number;
    containerCssClass?: string;
}

class MultipleComponentPopup extends React.Component<PropsWithChildren<IMultipleComponentPopup>, never> {
    public onClick(e: React.MouseEvent): void {
        if (this.props.shouldCloseOnClickOutside) {
            e.stopPropagation();
            if (e.target !== e.currentTarget) {
                return;
            }

            this.props.onCloseCallback();
        }
    }

    public render(): JSX.Element {
        const additionalCssClass = this.props.containerCssClass ? ` ${this.props.containerCssClass}` : "";
        let containerCss = `popup-multiple-element-container${additionalCssClass}`;

        if (this.props.isBackgroundGrey) {
            containerCss += " popup-grey-background";
        }

        let contentCss = "popup-multiple-content";
        if (this.props.contentJustification) {
            switch (this.props.contentJustification) {
                case "left":
                    contentCss += " popup-justify-content-left";
                    break;
                case "right":
                    contentCss += " popup-justify-content-right";
                    break;
                default:
                    contentCss += " popup-justify-content-center";
            }
        }
        let marginTopstyle: React.CSSProperties = {};
        if (this.props.contentMarginTop) {
            marginTopstyle = { "marginTop": this.props.contentMarginTop + "px" };
        }
        return (
            <div
                className={containerCss}
                style={marginTopstyle}
                onClick={e => this.onClick(e)}
            >
                <div
                    className={contentCss}
                    onClick={e => this.onClick(e)}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export { MultipleComponentPopup };
